// Normalise CMS form-module email inputs to lowercase + trim just before submit.
// Capture-phase listener runs before bubble-phase jQuery submit handlers, so if a form
// is submitted via AJAX ($form.serialize()) the normalised value is what gets sent.
// Scoped to .js-lowercase-email, which only the form module's email include renders.

export function lowercaseEmails(form) {
	form.querySelectorAll('input.js-lowercase-email').forEach((input) => {
		const normalised = input.value.trim().toLowerCase();
		if (input.value !== normalised) {
			input.value = normalised;
		}
	});
}

document.addEventListener('submit', (event) => {
	if (event.target instanceof HTMLFormElement) {
		lowercaseEmails(event.target);
	}
}, true); // capture phase
